export default "__VITE_ASSET__Cwqhdn1R__"